export default __webpack_public_path__ + "static/media/Icon.a403f205.svg";